<template>
    <ul class="footers">
        <li @click="homeH">
            <router-link to="/home">
                <img :src="isHomeH ? require('../assets/imgs/footer/homeH.png'):require('../assets/imgs/footer/home.png')" alt="">
                <p>首页</p>
            </router-link>
        </li>
        <li @click="classH">
            <router-link to="/classify">
                <img :src="isClassH ? require('../assets/imgs/footer/classH.png'):require('../assets/imgs/footer/class.png')" alt="">
                <p>分类</p>
            </router-link>
        </li>
        <li @click="selfH">
            <a href="javascript:;">
                <img :src="isSelfH ? require('../assets/imgs/footer/selfH.png'):require('../assets/imgs/footer/self.png')" alt="">
                <p>我的</p>
            </a>
        </li>
    </ul>
</template>
<script>
let Base64 = require('js-base64').Base64;
export default {
    data() {
        return {
            isHomeH: true,
            isClassH: false,
            isSelfH: false,
            decodeToken: null,
            errMsg: ''
        }
    },
    computed: {
        routePath() {
            return this.$route.path
        }
    },
    created() {
        var that = this;
        that.actives();
    },
    mounted() {
    },
    methods: {
        actives() {
            var that = this;
            if( that.routePath == "/home" ) {
                that.isHomeH = true;
                that.isClassH = false;
                that.isSelfH = false;
            }else if( that.routePath == "/classify" ) {
                that.isHomeH = false;
                that.isClassH = true;
                that.isSelfH = false;
            }else if( that.routePath == "/self" || that.routePath == "/login" ) {
                that.isHomeH = false;
                that.isClassH = false;
                that.isSelfH = true;
            }
        },
        homeH() {

        },
        classH() {

        },
        selfH() {
            var that = this;
            if( localStorage.getItem("errMsg") ) {
                // that.errMsg = localStorage.getItem("errMsg");
                let data = {
                    msg: localStorage.getItem("errMsg")
                }
                that.$emit("dialogChange", data);
            }else{
                if( localStorage.getItem("status") == "false" || !localStorage.getItem("status") ) {
                    this.$router.push("/login");
                }else{
                    this.$router.push("/self");
                }
            }
            
        },
    },
    watch: {
        routePath(newV){
            var that = this;
            that.actives();
        }
    }
}
</script>
<style lang="scss" scoped>
@function rem($args) {
    $uiWidth: 75px;
    @return $args/$uiWidth*1rem;
}
.footers{
    position: absolute;
    left: 0;
    bottom: 0;
    height: rem(114px);
    width: 100%;
    border-top: 1px solid #efeff3;
    background: #fff;
    text-align: center;
    display: flex;
    justify-content: space-around;
    >li{
        flex: 1;
        padding-top: rem(18px);
        >a{
            display: block;
            >img{
                display: block;
                width: rem(44px);
                height: rem(44px);
                margin: 0 auto rem(10px);
            }
            >p{
                color: #333;
                font-size: rem(20px);
            }
        }
    }
}
</style>
